import React from "react";
import * as S from "./Loading.styles";
import { SyncLoader } from "react-spinners";

const Loading = ({ loading }) => {
  return (
    <S.Loading>
      <SyncLoader loading={loading} margin={5} size={8} speedMultiplier={1} />
    </S.Loading>
  );
};

export default Loading;
